import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type { ITeam } from 'modules/teams/store/models/Team'

import EditModal from '../EditModal'
import Leaders from './Leaders'
import Members from './Members'

interface Props {
  team: ITeam
  readonly: boolean
  contractVersions: ContractVersions
}

const Detail = ({ team, readonly, contractVersions }: Props) => {
  const [openEditModal, setOpenEditModal] = React.useState(false)

  return (
    <Box>
      <Leaders team={team} readonly={readonly} contractVersions={contractVersions} />
      <Members team={team} readonly={readonly} contractVersions={contractVersions} />
      <Box alignItems="center">
        {openEditModal && <EditModal onClose={() => setOpenEditModal(false)} team={team} />}
      </Box>
    </Box>
  )
}

export default observer(Detail)
